import Button from 'atoms/Button/Button';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import HubspotFormWrapper from 'molecules/HubspotForm/HubspotFormWrapper';
import React from 'react';
import { submitHubSpotFormBuilder } from 'src/functions/hubspot/hubspot.service';

interface FormContentProps {
  formId: string;
  disabled?: boolean;
  headingText?: string;
  supportingText?: string;
  hideLegal?: boolean;
  buttonText?: string;
  legalText?: string;
}

const FormContent = ({
  formId,
  disabled = false,
  headingText = 'Could this be the decision that changes everything?',
  supportingText = 'Your first name and email are the only things standing between you and 9 SIMPLE STEPS to $1M',
  buttonText = 'Unlock People Magic Profit',
  legalText = 'By signing up you’re opting in to emails from us about the free masterclass, the podcast, and other helpful guides and goodies. You can unsubscribe at any time.',
  hideLegal = false,
}: FormContentProps): JSX.Element => (
  <Grid
    totalColumns={1}
    maxWidthMd='width-sm'
  >
    <Stack
      direction='column'
      gap='spacing-2xl'
      margin={['spacing-none', 'spacing-auto']}
    >
      <HeadingAndSupportingText
        heading={{
          text: headingText,
          type: 'heading',
          size: 'sm',
          fontWeight: 'font-weight-semibold',
        }}
        supportingText={{
          text: supportingText,
          type: 'paragraph',
          size: 'lg',
          color: 'text-tertiary',
        }}
        gap='spacing-xl'
      />
      <HubspotFormWrapper
        id={formId}
        hideLegal={hideLegal}
      />
      <Button
        variant='primary'
        type='submit'
        size='lg'
        disabled={disabled}
        onClick={submitHubSpotFormBuilder(`#${formId}`)}
      >
        {buttonText}
      </Button>

      <Typography
        type='paragraph'
        size='xs'
        color='text-tertiary'
      >
        {legalText}
      </Typography>
    </Stack>
  </Grid>
);

export default FormContent;
